import { AppConstant } from '@d-constants';
import { USER_LEVEL } from '@d-constants/user.constant';
import { IDialogUserLevel } from '@d-models/other/user.model';
import { createReducer, on } from '@ngrx/store';
import {
  updateDialogTenants,
  updateDialogCurrentUser,
  updateDialogProgramOwnerId,
  updateDialogUser,
  updateDialogUserLevel,
  updateCurrentTenantInfo,
} from './user.action';

export const userReducer = createReducer(
  localStorage.getItem(AppConstant.LocalStorageKey.DIALOGUser)
    ? JSON.parse(
        <string>localStorage.getItem(AppConstant.LocalStorageKey.DIALOGUser),
      )
    : {
        user: null,
        level: {
          tenantId: '',
          companyId: '',
          level: USER_LEVEL.TENANT_LEVEL,
        } as IDialogUserLevel,
      },
  on(updateDialogUser, (state, payload) => {
    return {
      ...state,
      user: payload.user,
      level: payload.level,
    };
  }),
  on(updateDialogCurrentUser, (state, payload) => {
    const newState = {
      ...state,
      user: payload.user,
    };
    if (!state.level.tenantId) {
      newState.level = { ...newState.level, tenantId: payload.user.tenantId };
    }
    return newState;
  }),
  on(updateDialogUserLevel, (state, payload) => {
    const newState = {
      ...state,
      level: {
        ...state.level,
        ...payload,
      },
    };
    localStorage.setItem(
      AppConstant.LocalStorageKey.DIALOGUser,
      JSON.stringify(newState),
    );
    return newState;
  }),
  on(updateDialogProgramOwnerId, (state, payload) => {
    const newState = {
      ...state,
      level: { ...state.level, ...payload },
    };
    localStorage.setItem(
      AppConstant.LocalStorageKey.DIALOGUser,
      JSON.stringify(newState),
    );
    return newState;
  }),
  on(updateDialogTenants, (state, payload) => {
    const newState = {
      ...state,
      tenants: payload.tenants,
    };
    return newState;
  }),
  on(updateCurrentTenantInfo, (state, payload) => {
    return {
      ...state,
      currentTenant: {
        ...state.tenants?.find((t: any) => t.id === state.level.tenantId),
        ...payload.tenantInfo,
      },
    };
  }),
);
